import { render } from "./UserManagement.vue?vue&type=template&id=0e5f2a0d"
import script from "./UserManagement.vue?vue&type=script&lang=js"
export * from "./UserManagement.vue?vue&type=script&lang=js"
script.render = render

export default script